import { Text, tokens } from '@fluentui/react-components';

interface CompletionCountProps {
  completedFields: number;
  totalFields: number;
  onBrand?: boolean;
}

export const CompletionCount = ({
  completedFields,
  totalFields,
  onBrand = false,
}: CompletionCountProps) => {
  if (totalFields === 0) return null;

  return (
    <Text
      size={200}
      style={{
        whiteSpace: 'nowrap',
        color: onBrand
          ? tokens.colorNeutralForegroundOnBrand
          : tokens.colorNeutralForeground2,
      }}
    >
      {completedFields}/{totalFields}
    </Text>
  );
};
